module.exports = __webpack_public_path__ + "static/certifications-c7a0090fe045b63bfb75a693671714b2.jpg";